// eslint-disable-next-line @typescript-eslint/no-var-requires
const IsDayOffAPI = require('isdayoff')();

export default IsDayOffAPI;
